import { type LatLngBoundsExpression, type LatLngBoundsLiteral, type LatLngExpression } from "leaflet";

import { type MeasuresSummarizedDto } from "../types/dashboardDatasetDto";

export const defaultMinLat = 40;
export const defaultMaxLat = 50;
export const defaultMinLon = 6;
export const defaultMaxLon = 8;

export interface LeafletBoundsAndCenter {
  center: LatLngExpression;
  bounds: LatLngBoundsLiteral;
}

export function calculateGeoBoundingBox(coordinatesData: MeasuresSummarizedDto): {
  minLat: number;
  maxLat: number;
  minLon: number;
  maxLon: number;
} {
  const latitudes: number[] = [];
  const longitudes: number[] = [];

  if (coordinatesData?.data) {
    for (const data of coordinatesData.data) {
      if (data?.lat && data?.lon) {
        longitudes.push(data.lon);
        latitudes.push(data.lat);
      }
    }
  }

  return {
    minLat: latitudes.length > 0 ? Math.min(...latitudes) : defaultMinLat,
    maxLat: latitudes.length > 0 ? Math.max(...latitudes) : defaultMaxLat,
    minLon: longitudes.length > 0 ? Math.min(...longitudes) : defaultMinLon,
    maxLon: longitudes.length > 0 ? Math.max(...longitudes) : defaultMaxLon,
  };
}

export function calculateCenterAndBounds(coordinatesData: MeasuresSummarizedDto): LeafletBoundsAndCenter {
  const { minLat, maxLat, minLon, maxLon } = calculateGeoBoundingBox(coordinatesData);

  const centerLat = (minLat + maxLat) / 2;
  const distanceLatitude = maxLat - minLat;
  const bufferLatitude = distanceLatitude * 0.1;
  const centerLong = (minLon + maxLon) / 2;
  const distanceLong = maxLon - minLon;
  const bufferLongitude = distanceLong * 0.1;

  const center: LatLngExpression = [centerLat, centerLong];
  const bounds: LatLngBoundsExpression = [
    [minLat - bufferLatitude, minLon - bufferLongitude],
    [maxLat + bufferLatitude, maxLon + bufferLongitude],
  ];
  return { center, bounds };
}
